import { subStepsIds } from '../WizardModel/constants'

let wf_adult_someoneelse = [
    {
        id: subStepsIds.ParticipantType,
        getNextStepId: (state) => {
            return subStepsIds.BowlerMembership;
        }
    },
    {
        id: subStepsIds.BowlerMembership,
        getNextStepId: (state) => {
            if (state.bowlerMembership == "Yes") {
                return subStepsIds.MembershipSearch;
            } else {
                return subStepsIds.EditBowlerInfo;
            }
        }
    },
    {
        id: subStepsIds.MembershipSearch,
        getNextStepId: (state) => {
            return subStepsIds.ViewBowlerInfo;
        }
    },
    {
        id: subStepsIds.MembershipCostAck,
        getNextStepId: (state) => {
            return subStepsIds.Consent;

        }
    },
    {
        id: subStepsIds.ViewBowlerInfo,
        getNextStepId: (state) => {
            return subStepsIds.Consent;
        }
    },
    {
        id: subStepsIds.EditBowlerInfo,
        getNextStepId: (state) => {
            return subStepsIds.MembershipCostAck;
        }
    },
    {
        id: subStepsIds.Consent,
        getNextStepId: (state) => {
            if (state.isPaymentRequired)
                return subStepsIds.ReviewAndPay;
            else
                return subStepsIds.Finished;
        }
    },
    {
        id: subStepsIds.ReviewAndPay,
        getNextStepId: (state) => {
            return subStepsIds.Finished;
        }
    },
];

export default wf_adult_someoneelse;



